






import { Component, Vue } from 'vue-property-decorator';
import LayoutDashboard from '@/layouts/Dashboard.vue';

@Component({
  components: {
    LayoutDashboard,
  },
})
export default class PageBannerIndex extends Vue {
}
